import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  CaretRightIcon,
  IconButton,
} from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import styles from "./Sharing.module.scss"
import { followToFollowerFull } from "src/utils"

interface FollowerProps {
  follow: Follow;
}

/*
 * display info about a follower
 */
export function Follower(props: FollowerProps) {
  const { follow } = props

  return (
    <li>
      <Link
        to={"/data_sharing/sharing/$followId/manage_follower"}
        params={{ followId: follow.id }}
        id={`follow-${follow.id}`}
        className={styles.listItemContainer}
      >
        <span
          className={styles.listItemName}
          id="active-follower"
        >
          {followToFollowerFull(follow)}
        </span>
        <IconButton
          className={styles.listItemSettingsButton}
          stylePreset="withoutBackground"
        >
          <CaretRightIcon />
        </IconButton>
      </Link>
    </li>
  )
}
